const FAQ = () => {
  const items = [
    { q: "Hur lång tid tar det att komma igång?", a: "De flesta firmor kör skarpt inom en arbetsdag. Du skapar din första offert direkt och vi hjälper dig komma igång. På Firma ingår migrering från befintliga system." },
    { q: "Vad är skillnaden mellan paketen?", a: "Start ger dig allt du behöver för att hantera affärer och offertera — inkorg, mallar, ROT-avdrag och e-signatur. Bygg lägger till projektstyrning med budget vs utfall, integrationer mot Offerta och Servicefinder, och AI-tolkning av förfrågningar. Firma ger AI-utkast på offerter från historiska projekt, OCR & dokumentscanning, mönsteranalys och dedikerad kontaktperson." },
    { q: "Hur hanteras ROT-avdrag och moms?", a: "Byggro räknar automatiskt ROT på arbetskostnad enligt gällande regler och separerar moms korrekt. Ingår i alla paket." },
    { q: "Vad innebär AI-funktionerna?", a: "I Bygg tolkar AI:n inkommande förfrågningar automatiskt. I Firma föreslår AI:n hela offertutkast baserade på liknande tidigare projekt och analyserar mönster i din lönsamhet per jobbtyp och kund." },
    { q: "Vad händer med vår data om vi slutar?", a: "All din data ägs av dig. Du kan när som helst exportera kunder, projekt och offerter. Vi raderar säkerhetskopior senast 90 dagar efter uppsägning. All data lagras inom EU." },
    { q: "Vi är två snickare i ett AB. Är Byggro overkill?", a: "Nej. Start-paketet är byggt för dig — 395 kr i månaden. Du får inkorg för nya affärer, offerter med e-signatur och automatisk ROT-hantering. Gå upp till Bygg den dagen du behöver projektstyrning." },
  ];

  const [open, setOpen] = React.useState(0);

  return (
    <section className="section" id="faq">
      <div className="container">
        <div className="section-head">
          <h2>Det vi får mest frågor om.</h2>
        </div>
        <div className="faq-list">
          {items.map((it, i) => (
            <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
              <button onClick={() => setOpen(open === i ? -1 : i)} className="faq-q">
                <span>{it.q}</span>
                <span className="faq-icon">{open === i ? '–' : '+'}</span>
              </button>
              {open === i && <div className="faq-a">{it.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

Object.assign(window, { FAQ });
